import { render, staticRenderFns } from "./Professional_Research.vue?vue&type=template&id=5f0c6847&scoped=true&"
import script from "./Professional_Research.vue?vue&type=script&lang=js&"
export * from "./Professional_Research.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c6847",
  null
  
)

export default component.exports